module.exports = __webpack_public_path__ + "static/media/logsActive.e7b41f44.png";